import {ALGO_ASSET, TinymanAnalyticsApiAsset} from "@tinymanorg/tinyman-js-sdk";

import webStorage, {STORED_KEYS} from "../../util/storage/webStorage";
import {AssetListItemData, VerifiedAssets} from "./assetModels";
import {IS_USING_MAINNET} from "../../core/constants";

const cachedAssetsStoredValue = webStorage.getFromWebStorage(
  STORED_KEYS.TINYMAN_CACHED_ASSETS
);

const CACHED_ASSETS: Record<
  string,
  {asset: TinymanAnalyticsApiAsset; isDeleted: boolean}
> = (typeof cachedAssetsStoredValue === "object" ? cachedAssetsStoredValue : null) || {};

const LIQUIDITY_TOKEN_DECIMALS = 6;
const ASSET_LOGO_BASE_URL = "https://asa-list.tinyman.org";
const ALGO_ASSET_LIST_ITEM_DATA: AssetListItemData = {
  ...ALGO_ASSET,
  balance: 0n
};

/** The minimum total supply amount for an asset to be able to be used as a pool asset */
const POOL_CONSTITUENT_ASSET_MIN_TOTAL_SUPPLY = 1_000_000;

const USDC_ASSET: AssetListItemData = {
  id: IS_USING_MAINNET ? "31566704" : "10458941",
  name: "USDC",
  unit_name: "USDC",
  decimals: 6,
  url: "",
  is_liquidity_token: false,
  total_amount: "18446744073709552000",
  balance: 0n,
  clawback_address: ""
};

const DEFAULT_VERIFIED_ASSETS: VerifiedAssets = IS_USING_MAINNET
  ? {
      [`${ALGO_ASSET.id}`]: {asset_id: `${ALGO_ASSET.id}`, verification_tier: "trusted"}
    }
  : {
      [`${ALGO_ASSET.id}`]: {
        asset_id: `${ALGO_ASSET.id}`,
        verification_tier: "trusted"
      },
      // TINYUSDt
      "21582818": {asset_id: "21582818", verification_tier: "suspicious"},
      // TINYAU
      "21582981": {asset_id: "21582981", verification_tier: "unverified"}
    };

const POOLS_REMOVED_FROM_TVL_CALCULATION = [
  {
    address: "URVE4HCAEMFXEU5QWKN7W4BTLX724GYKMP675WKXZJUTNOLTI7RRDKR4C4",
    name: "ITVL / GTVL",
    asset_1: {
      id: "758204859",
      unit_name: "GTVL"
    },
    asset_2: {
      id: "758205935",
      unit_name: "ITVL"
    }
  },
  {
    address: "T352SECERNX4CZANVE5EBKNAJ2TNUMQFM3MOCTX5BVLEYBRUYIKZGO7MMM",
    name: "GTVL2 / ITVL",
    asset_1: {
      id: "758205935",
      unit_name: "ITVL"
    },
    asset_2: {
      id: "764075427",
      unit_name: "GTVL2"
    }
  }
];

const ADDRESS_OF_POOLS_REMOVED_FROM_TVL = new Set(
  POOLS_REMOVED_FROM_TVL_CALCULATION.map((pool) => pool.address)
);

const ASSETS_OF_POOLS_REMOVED_FROM_TVL = new Set(
  POOLS_REMOVED_FROM_TVL_CALCULATION.flatMap((pool) => [
    Number(pool.asset_1.id),
    Number(pool.asset_2.id)
  ])
);
/* eslint-enable no-magic-numbers */

export {
  CACHED_ASSETS,
  ALGO_ASSET_LIST_ITEM_DATA,
  LIQUIDITY_TOKEN_DECIMALS,
  ASSET_LOGO_BASE_URL,
  USDC_ASSET,
  POOL_CONSTITUENT_ASSET_MIN_TOTAL_SUPPLY,
  DEFAULT_VERIFIED_ASSETS,
  ADDRESS_OF_POOLS_REMOVED_FROM_TVL,
  ASSETS_OF_POOLS_REMOVED_FROM_TVL
};
